export default {
  data: () => ({
    i18n_mode: process.env.VUE_APP_LANG_MODE,
    // i18n_mode: 'jp',
    i18n_message: {
      カード: {
        en: 'Card',
      },
      フィギュア: {
        en: 'Figure',
      },
      ゲーム: {
        en: 'Game',
      },
      遊戯王: {
        en: 'Yugioh',
      },
      ポケモン: {
        en: 'Pokemon',
      },
      ヴァイスシュバルツ: {
        en: 'Weiβ Schwarz',
      },
      シャドウバース: {
        en: 'Shadowverse',
      },
      ワンピース: {
        en: 'ONE PIECE',
      },
      'デュエル・マスターズ': {
        en: 'Duel Masters',
      },
      'マジック:ザ・ギャザリング': {
        en: 'Magic: The Gathering',
      },
      一覧: {
        en: 'See More',
      },
      お問い合わせ先: {
        en: 'Contact information',
      },
      メール送信: {
        en: 'Send mail',
      },
      パック: {
        en: 'pack',
      },
      購入する: {
        en: 'BUY',
      },
      残数: {
        en: 'residue',
      },
      商品説明: {
        en: 'Description of item',
      },
      特定商取引法について: {
        en: 'Specified Commercial Transaction Law',
      },
      を消費し: {
        en: 'consume',
      },
      パック購入します: {
        en: 'buy a pack',
      },
      '24時間ずっと引けるオンラインガチャ': {
        en: '"GACHA" system - available 24 hours -',
      },
      '商品に封入したカードの排出確率はすべて同じです。確認操作等は一切しておりません。': {
        en: '*What you get is completely random',
      },
      'tokkyo.png': {
        en: 'tokkyo_eng.png',
      },
      // 特定商取引法: {
      //   en: '',
      // },
      // 利用規約: {
      //   en: '',
      // },
      // 個人情報保護ポリシー: {
      //   en: '',
      // },
      // 個人情報保護: {
      //   en: '',
      // },
      ご利用ガイド: {
        en: 'User Guide',
      },
      ログイン: {
        en: 'Sign in',
      },
      会員ログイン: {
        en: 'Sign in',
      },
      ログアウト: {
        en: 'Log out',
      },
      さん: {
        en: ' ',
      },
      マイページ: {
        en: 'My page',
      },
      新規会員登録: {
        en: 'Create your Account',
      },
      メールアドレス: {
        en: 'Email address',
      },
      パスワード: {
        en: 'Login Password',
      },
      次回以降入力を省略する: {
        en: 'Skip input from next time',
      },
      パスワードをお忘れの場合はこちら: {
        en: 'Forgot your password?',
      },
      'HPで既に会員登録を頂いている方も、こちらをご利用': {
        en: 'You need to create your account if you have already registered for our stores below.',
      },
      'いただく際は、新規会員登録が必須となります。': {
        en: ' ',
      },
      '※HPでの会員登録情報と同じでも構いません。': {
        en: ' ',
      },
      仮パスワード発行: {
        en: 'Reset password',
      },
      入力してください: {
        en: 'Please input',
      },
      メールアドレスまたはパスワードが一致しません: {
        en: 'Email address or password do not match',
      },
      会員登録: {
        en: 'Membership Registration',
      },
      '以下に登録情報をご入力ください。': {
        en: 'Please fill out the form below',
      },
      購入内容確認: {
        en: 'Confirmation of Purchase',
      },
      購入商品名: {
        en: 'Item Name',
      },
      消費ポイント: {
        en: 'Payment amount (Points)',
      },
      所持ポイント: {
        en: 'Total Points',
      },
      'よろしいですか？': {
        en: 'Is that OK?',
      },
      はい: {
        en: 'OK',
      },
      いいえ: {
        en: 'NO',
      },
      商品ページに戻る: {
        en: 'Back to previous page',
      },
      お支払い方法について: {
        en: 'About Payment',
      },
      発送方法について: {
        en: 'About Shipping',
      },
      返品特約と期限について: {
        en: 'About Deadline for returns',
      },
      ポイント購入確認: {
        en: 'Confirmation of Point Purchase',
      },
      購入ポイント: {
        en: 'The Amount of Points you purchase',
      },
      お支払い金額: {
        en: 'The Amount of Money for payment',
      },
      '上記内容でよろしいですか？': {
        en: 'Is that OK?',
      },
      キャンセル: {
        en: 'Cancel',
      },
      決済にすすむ: {
        en: 'To Payment',
      },
      購入にあたって: {
        en: 'About Purchase',
      },
      お支払いについて: {
        en: 'About payment',
      },
      各種クレジットカード: {
        en: 'Various credit cards',
      },
      発送日: {
        en: 'About shipping',
      },
      消費税について: {
        en: 'About Tax',
      },
      氏名: {
        en: 'Name',
      },
      姓: {
        en: 'First name',
      },
      ミドルネーム: {
        en: 'Middle name',
      },
      名: {
        en: 'Last name',
      },
      電話番号: {
        en: 'Tel',
      },
      '「−」ハイフンは不要です': {
        en: ' ',
      },
      '@yahooや@gmailなどを推奨します': {
        en: ' ',
      },
      郵便番号: {
        en: 'Zip code',
      },
      市区町村: {
        en: 'City',
      },
      番地: {
        en: 'Address1',
      },
      建物名: {
        en: 'Address2',
      },
      パスワード確認用: {
        en: 'Confirm password',
      },
      半角英数字6文字以上20文字以内: {
        en: ' ',
      },
      建物名を入力してください: {
        en: ' ',
      },
      番地を入力してください: {
        en: ' ',
      },
      '配送トラブル防止のため、該当する場合は略さずに必ず記載して下さい。': {
        en: ' ',
      },
      国名: {
        en: 'Country',
      },
      入力内容を確認する: {
        en: 'Create an account',
      },
      入力内容確認: {
        en: 'Input content confirmation',
      },
      修正する: {
        en: 'fix',
      },
      登録する: {
        en: 'Sign up',
      },
      登録完了: {
        en: 'Completion of registration',
      },
      会員のご登録: {
        en: 'Register as a member',
      },
      ラインナップ: {
        en: 'Line up',
      },
      'ありがとうございました。': {
        en: 'Thank you very much.',
      },
      引き続き商品のご購入を: {
        en: 'Continue to purchase products',
      },
      'お楽しみください。': {
        en: 'Please enjoy.',
      },
      TOPページへ: {
        en: 'go to top',
      },
      お問い合わせ: {
        en: 'Contact us',
      },
      次へ: {
        en: 'next',
      },
      '登録内容をご確認ください。': {
        en: 'Please check your registration details.',
      },
      パスワードを変更する: {
        en: 'change the password',
      },
      更新する: {
        en: 'Update',
      },
      ポイント購入: {
        en: 'Purchase Points',
      },
      ポイント履歴: {
        en: 'Your Points history',
      },
      ポイント利用規約: {
        en: 'Points Terms of Use',
      },
      最終確認: {
        en: 'Confirmation of Purchase',
      },
      '商品を購入しました！': {
        en: 'Your order has been completed.',
      },
      SMS認証: {
        en: 'SMS authentication',
      },
      発送確認完了: {
        en: 'Completed',
      },
      利用規約: {
        en: 'Terms of service',
      },
      '利用規約 ': {
        en: 'Terms of service',
      },
      金額: {
        en: 'price',
      },
      発送カード: {
        en: 'Shipped items',
      },
      発送済みカード: {
        en: 'Shipped items',
      },
      一覧へ戻る: {
        en: 'Back to the list',
      },
      ポイント還元したカード: {
        en: 'Items Converted to Points',
      },
      '購入・還元ポイント': {
        en: 'point history',
      },
      '購入履歴がありません。': {
        en: 'No purchase history.',
      },
      'この度はご利用くださり、': {
        en: 'Thank you for your purchase.',
      },
      '誠にありがとうございました。': {
        en: ' ',
      },
      '商品購入履歴がありません。': {
        en: 'There is no product purchase history.',
      },
      発送済み: {
        en: 'Shipped',
      },
      未発送: {
        en: 'Unshipped',
      },
      発送なし: {
        en: 'No shipped',
      },
      '選択済み/未発送': {
        en: 'No select',
      },
      商品名: {
        en: 'Items',
      },
      ポイント数: {
        en: 'Points',
      },
      発送状況: {
        en: 'Delivery status',
      },
      '発送希望いただいた商品は、': {
        en: 'Items you chose to get will be shipped within 7-14 days.',
      },
      '土日祝を除く14営業日以内に発送いたします。': {
        en: ' ',
      },
      'またご縁をいただけることがございましたら、': {
        en: ' ',
      },
      '何卒よろしくお願いいたします。': {
        en: ' ',
      },
      商品購入履歴: {
        en: 'Purchase history',
      },
      コードを送信する: {
        en: 'send code',
      },
      新しいパスワード: {
        en: 'new password',
      },
      新しいパスワード確認用: {
        en: 'For new password confirmation',
      },
      発送商品数: {
        en: 'The number of items be shipped',
      },
      選択ページに戻る: {
        en: 'Back to previous page',
      },
      還元ポイント: {
        en: 'Points you get',
      },
      変更する: {
        en: 'Change',
      },
      発送するカード: {
        en: 'Items be shipped',
      },
      ポイント還元するカード: {
        en: 'Items converted to points',
      },
      還元: {
        en: 'Converted to',
      },
      半角英数字15文字以内: {
        en: ' ',
      },
      パスワード変更: {
        en: 'change password',
      },
      'パスワードを変更しました。': {
        en: 'Password changed.',
      },
      パスワード確認用と一致しません: {
        en: 'Does not match password confirmation',
      },
      獲得カード一覧: {
        en: 'All Items you got',
      },
      購入日: {
        en: 'Purchase Date',
      },
      販売開始まで: {
        en: 'Until sales start',
      },
      '1回': {
        en: 'One payment of ',
      },
      全: {
        en: 'All ',
      },
      回: {
        en: 'packs',
      },
      セキュリティコード: {
        en: 'security code',
      },
      有効期限: {
        en: 'date of expiry',
      },
      購入数: {
        en: 'Purchase number',
      },
      '発送希望のカードを選択してください。': {
        en: 'Please choose items you want to get by putting check marks.',
      },
      '発送を希望されない商品はポイントにて還元いたします。': {
        en: 'Other items will be converted to points according to values of each item.',
      },
      'お客様情報を更新しました。': {
        en: 'Updated customer information.',
      },
      'SMSコードを送信しますか？': {
        en: 'Send SMS code?',
      },
      'SMS認証が完了しました。': {
        en: 'SMS verification completed.',
      },
      '登録情報を確認・更新する': {
        en: 'Update your information',
      },

      '１.ログイン頂いた状態で、ポイント購入画面から、ポイントをご購入ください。': {
        en: 'Firstly, please purchase our points after login your account.',
      },
      'お支払いが完了いたしましたら、画面上の数字が変動いたします。': {
        en: 'You can check your latest points on the screen, and confirm that your purchase has been reflected.',
      },
      '※銀行振込などの場合は、ご入金を確認させて頂き次第の反映となりますので、反映まで最大数日かかる場合がございますこと、予めご容赦くださいませ。': {
        en: '※) If you use "PayPal", it will take time to update your points.',
      },

      '２.購入したい商品を全て選び終えましたら、購入手続きに進んで下さい。': {
        en: 'Continue payment procedures if you have decided what you are going to buy.',
      },
      '３.購入いただいた商品が一覧で表示されます。': {
        en: 'All items you picked up will be shown on the screen.',
      },
      'その中から、発送希望商品とポイントへ還元する商品を24時間以内にご選択ください。': {
        en: "Then, please choose items you want to get within 24 hours(※). Items you don't need will be converted to points according to the value of each item.",
      },
      '24時間を過ぎますと、自動で購入いただいた商品が全てポイントに還元されます。': {
        en: "(※) All items you picked up will be converted to points if you don't make choices within 24 hours.",
      },
      '原則、ご利用日から3日〜7日以内の発送となります。': {
        en: 'Basically, the items you chose to get will be shipped within 7-14 days.',
      },

      '※送料が無料のため、複数回ご利用いただき、発送依頼をご選択された場合には、全てまとめて発送させて頂きます。': {
        en: '(※) We will send your items in one batch when you buy various items.',
      },
      '以下に配送等への留意事項を記載させて頂きます。': {
        en: 'Points of Attention Regarding Payment and Shipping',
      },
      '※クレジットカードによる不正決済防止のため、ご本人様確認や調査を行わせて頂くことがございます。': {
        en: 'We might ask you some questions for identity verification to prevent the abuse of credit cards.',
      },
      'そのため、発送までにお時間がかかる場合がございます。': {
        en: 'It will take time when such investigation be needed.',
      },
      '発送させて頂き次第、発送通知の上、追跡番号を反映いたします。': {
        en: 'Once it is shipped, we will notify you and the tracking number will be shown on your pages.',
      },
      '※発送件数が多い時や、他業務がある際は、上記期日を超える場合がございます。': {
        en: 'The shipment might be delayed for some reasons.',
      },
      '※ご登録先のご住所等に誤りがあった場合には、正しく発送されない場合があり、弊社では対応できかねますので、正しいご住所をご登録ください。': {
        en: 'Items might be delivered to the wrong address if you fill in incorrect information. We cannot take responsibility for such wrong delivery including other delivery accidents.',
      },
      '本件におきまして、ご質問等ございましたら、gacha24@iranoan.comへご連絡くださいませ。': {
        en: 'Please contact us at the address below if you have any questions. overseas.gacha24@gmail.com',
      },
      '表示されている金額は全て税込(10%)となります。': {
        en: 'All Items in our stores are tax included.',
      },
      '(1円未満は四捨五入)': {
        en: ' ',
      },
      '決済が成功し、ポイントに反映しました。': {
        en: 'The payment was successful and reflected in the points.',
      },
      '決済が失敗しました。クレジットカードの状態をご確認ください。\n状態が不明な場合は、クレジットカード会社にお問い合わせください。': {
        en: 'Payment failed. Please check the status of your credit card.\n'
          + 'If you are unsure of the status, please contact your credit card company.',
      },
      カード番号: {
        en: 'card number',
      },
      'カード(年月)': {
        en: 'card year month',
      },
      'カード(セキュリティコード)': {
        en: 'security code',
      },
      カード名義: {
        en: 'card holder',
      },
      システムメンテナンス: {
        en: 'system maintenance',
      },
      通信エラー: {
        en: 'communication error',
      },
      その他: {
        en: 'other',
      },
      が不正です: {
        en: 'is illegal.',
      },
      決済方法を選択: {
        en: 'Select payment method',
      },
      '『キャリア決済・メルペイ・LINE Pay・PayPay』での決済をご希望の方は、': {
        en: 'If you would like to pay with "carrier billing, Merpay, LINE Pay, PayPay", you can also purchase at ',
      },
      'でも購入頂けます！': {
        en: '!',
      },
      'ポイントの即時反映をご希望の際は、クレジットカードでのご決済をご選択くださいませ。そのほかのご決済方法はお時間かかる場合がございます。': {
        en: 'If you would like your points to be reflected immediately, please select payment by credit card. Other payment methods may take longer.',
      },
      特定商取引法に基づく表記: {
        en: 'Specified Commercial Transaction Law',
      },
      資金決済法に基づく表記: {
        en: 'Act on Payment service',
      },
      個人情報保護ポリシー: {
        en: 'Privacy Statement ',
      },
      排出されるカードの一部を表示しております: {
        en: 'These are the prizes you might win in this "GACHA"',
      },
      運営会社名称: {
        en: 'Operating company name',
      },
      株式会社Iranoan: {
        en: 'Iranoan Co., Ltd.',
      },
      代表責任者: {
        en: 'Representative responsible person',
      },
      '鈴木 直': {
        en: 'Nao Suzuki',
      },
      '会社登記住所・営業所住所': {
        en: 'Company registration address/Business office address',
      },
      '埼玉県さいたま市大宮区三橋2-800-18': {
        en: '2-800-18 Mitsuhashi, Omiya Ward, Saitama City, Saitama Prefecture',
      },
      'ポイント(本サイト内通貨)所有上限・期限': {
        en: 'Points (currency in this site) Possession Limit and Expiration Date',
      },
      'ポイントの上限はございません。': {
        en: 'There is no maximum number of points.',
      },
      'ただし、ポイント購入及びポイント交換からポイントを使用することなく最終のご使用日から6ヶ月(当日を含む)が経過した場合、あらかじめお客様に通知することなくアカウントを削除することができます。': {
        en: 'However, if 6 months (including the day) have passed since the last use date without using points from point purchase or point exchange, the account can be deleted without prior notice to the customer.',
      },
      'この場合、ポイントは失効いたします。': {
        en: 'In this case, the points will expire.',
      },
      ポイント使用場所の範囲: {
        en: 'Range of locations where points can be used',
      },
      'ポイント(本サイト内通貨)は、ご登録されているアカウント内にてご利用可能となります。': {
        en: 'Points (in-site currency) can be used within your registered account.',
      },
      'また、アカウントの譲渡及びポイントの譲渡は禁止いたします。': {
        en: 'In addition, transfer of account and transfer of points are prohibited.',
      },
      ご利用上のご注意: {
        en: 'Precautions for use',
      },
      'ポイント(本サイト内通貨)の払い戻しは致しかねます。': {
        en: 'Points (in-site currency) cannot be refunded.',
      },
      所有ポイントの確認方法: {
        en: 'How to check owned points',
      },
      '本サイトの画面上にてご確認いただけます。': {
        en: 'You can check it on the screen of this site.',
      },
      '所有ポイントに動きがございましたら、そこの数字が自動で変化いたします。': {
        en: 'If there is movement in the owned points, the number there will change automatically.',
      },
      '以下の2つのうちのいずれかからご連絡ください。': {
        en: 'Please contact us through one of the two options below.',
      },
      'メールアドレス : gacha24@iranoan.com': {
        en: 'Email Address: overseas.gacha24@gmail.com',
      },
      'TEL : 048-729-7668': {
        en: 'TEL: +81 048-729-7668',
      },
      '048-729-7668': {
        en: '+81 048-729-7668',
      },
      '本サイトの利用規約をご確認ください。': {
        en: 'Please check the terms of use of this site.',
      },
      販売業者: {
        en: 'Act on specified commercial transactions distributor',
      },
      価格: {
        en: 'price',
      },
      各商品毎に表示: {
        en: 'Display for each product',
      },
      商品代金以外の必要料金: {
        en: 'Necessary charges other than product price',
      },
      '当社の提供するサービスを利用するための機器に関する費用、インターネット接続料金、パケット通信料、消費税、代金支払いの振込手数料': {
        en: 'Equipment costs for using the Services provided by the Company, Internet connection charges, packet communication charges, consumption tax, transfer fees for payment',
      },
      引渡時期: {
        en: 'Delivery time',
      },
      申込受付時: {
        en: 'When accepting applications',
      },
      販売数量: {
        en: 'Sales volume',
      },
      '特に指定はございません。': {
        en: 'There is no particular designation.',
      },
      '※商品によって数量制限設定あるものもございます。': {
        en: '*Some products have quantity restrictions.',
      },
      お支払い方法: {
        en: 'Payment method',
      },
      'クレジットカード・コンビニエンスストア・PayPal・銀行振込・キャリア決済・PayPay・LINEPay・メルペイとなります。': {
        en: 'Credit card, convenience store, PayPal, bank transfer, carrier billing, PayPay, LINEPay, Merpay.',
      },
      '※ご決済後のお客様都合によるキャンセルは承ることができませんこと、ご容赦ください。': {
        en: '*Please note that we cannot accept cancellations due to customer convenience after payment has been made.',
      },
      '銀行振込をご選択頂いた場合は、 下記の弊社口座まで3日以内にお振込をお願いいたします。': {
        en: 'If you choose bank transfer, please transfer the amount to our account below within 3 days.',
      },
      '期限までにお支払いがない場合、自動的にキャンセルとなります。': {
        en: 'If payment is not made by the deadline, it will be automatically canceled.',
      },
      'キャリア決済、PayPay、LINEPay、メルペイは': {
        en: 'Carrier billing, PayPay, LINEPay, Merpay can be purchased on the ',
      },
      'のHPで購入可能。': {
        en: ' website.',
      },
      '【住信SBIネット銀行】': {
        en: '[Sumishin SBI Net Bank]',
      },
      '法人第一支店（106）': {
        en: 'Corporate First Branch (106)',
      },
      普通: {
        en: 'usually',
      },
      'カ)イラノアン': {
        en: 'f) Iranian',
      },
      支払時期: {
        en: 'Payment period',
      },
      クレジットカード: {
        en: 'Credit card',
      },
      タップしてSTART: {
        en: 'Tap to start',
      },
      'クレジットカード会社の規約に基づく。': {
        en: 'Based on the terms of the credit card company.',
      },
      コンビニ決済: {
        en: 'Convenience store settlement',
      },
      '(ファミリーマートのみ)': {
        en: '(FamilyMart only)',
      },
      'ご注文日から３日以内に代金をお支払いください。': {
        en: 'Please make payment within 3 days from the date of order.',
      },
      '期限までにお支払いがない場合、自動的に注文キャンセルとなります。': {
        en: 'If payment is not made by the deadline, the order will be automatically canceled.',
      },
      銀行振込決済: {
        en: 'Bank Transfer',
      },
      'ご注文日から３営業日以内に代金をお支払いください。': {
        en: 'Payment Please make payment within 3 business days from the order date.',
      },
      'ご注文日から３営業日以内に代金をご送金ください。': {
        en: 'Please remit the payment within 3 business days from the order date.',
      },
      '期限までに送金がない場合、自動的に注文キャンセルとなります。': {
        en: 'If payment is not made by the deadline, the order will be automatically cancelled.',
      },
      キャリア決済: {
        en: 'Carrier',
      },
      '各キャリアの規約に基づく。': {
        en: 'billing Based on the terms of each carrier.',
      },
      'PayPayの規約に基づく。': {
        en: 'Based on the terms of PayPay.',
      },
      'LINEPayの規約に基づく。': {
        en: 'Based on LINEPay terms.',
      },
      メルペイ: {
        en: 'Merpay',
      },
      'メルペイの規約に基づく。': {
        en: 'Based on the terms of Merpay.',
      },
      返品特約と期限: {
        en: 'Return policy and deadline',
      },
      '返品・返還不可': {
        en: 'No returns/refunds',
      },
      '利用規約第22条記載のとおり、返品・返還やその他の保証は一切致しません。': {
        en: 'As stated in Article 22 of the Terms of Use, we do not offer any returns or refunds or any other guarantees.',
      },
      '許認可・資格': {
        en: 'Permits and qualifications',
      },
      古物商営業許可: {
        en: 'Secondhand dealer business license',
      },
      第431370040346: {
        en: 'No. 431370040346',
      },
      埼玉県公安委員会: {
        en: 'Saitama Prefectural Public Safety Commission',
      },
      配送依頼したカード: {
        en: 'The card you requested delivery',
      },
      '弊社では、ご利用者様が安心してご利用頂けるよう、最低限の個人情報をご提供頂いております。': {
        en: 'We ask you to provide us with personal information, which also makes you use our services with peace of mind.',
      },
      'また、弊社ではご提供頂いた個人情報の保護について最大限の注意を払っています。': {
        en: 'In addition, we pay the utmost attention to the protection of the personal information you provide.',
      },
      '弊社の個人情報保護についての考え方は以下の通りとなります。': {
        en: 'Our approach to personal information protection is as follows',
      },
      '(１)弊社では会員様により登録された個人及び団体や法人の情報については、最先端の機能やサービスを開発・提供するためにのみ利用し、会員個人情報の保護に細心の注意を払うものとします。': {
        en: '(1) We use personal, group, and corporate information registered by members only for the purpose of developing and providing cutting-edge functions and services, and pay close attention to the protection of member personal information.',
      },
      '(２)このプライバシーポリシーの適用範囲は、弊社で提供するサービスのみです。': {
        en: '(2) This privacy policy applies only to the Services provided by our Company.',
      },
      '(３)本規約に明記された場合を除き、目的以外の利用は致しません。': {
        en: '(3) We will not use it for any purpose other than the purpose specified in this agreement.',
      },
      '(４)本規約に明記された場合を除き、第三者への開示は致しません。': {
        en: '(4) We will not disclose personal information to third-parties except as specified in this agreement.',
      },
      '(５)その他本規約に規定された方法での適切な管理を定期的に行います。': {
        en: '(5) In addition, we will regularly perform appropriate management by the method stipulated in this agreement.',
      },
      '(６)弊社は利用者の許可なくして、プライバシーポリシーの変更をすることができます。': {
        en: '(6) We may change the privacy policy without the user\'s permission.',
      },
      '弊社が、個人情報取得内容の変更・利用方法の変更・開示内容の変更等をした際には、ご利用者様がその内容を知ることができるよう、弊社ホームページのお知らせに公開し、このプライバシーポリシーに反映することにより通知致します。': {
        en: 'When we change the content of personal information acquisition, change the method of use, change the content of disclosure, etc., we will publish it on our website notice so that users can know the content and this privacy policy.',
      },
      '第１項. 弊社のプライバシーポリシーについての考え方が適用される範囲': {
        en: 'SECTION 1: SCOPE OF APPLICATION OF OUR PRIVACY POLICY',
      },
      '(１)弊社のプライバシーポリシーについての考え方は、会員が弊社のサービスを利用される場合に適用されます。': {
        en: '(1) Our Company\'s privacy policy applies when members use our Company\'s services.',
      },
      '(２)会員が弊社のサービスを利用される際に収集される個人情報は、弊社の個人情報保護についての考え方に従って管理されます。': {
        en: '(2) Personal information collected when members use our services will be managed by our Company\'s approach to personal information protection.',
      },
      '(３)弊社の個人情報保護考え方は、弊社が直接提供されるサービスのみであり、他の組織や会社等のサービスは適用範囲外となります。': {
        en: '(3) Our approach to personal information protection applies only to services directly provided by our Company and does not apply to services of other organizations or companies.',
      },
      '(４)弊社のサービスのご利用は、ご利用者様の責任において行われるものとします。': {
        en: '(4) The use of our services shall be done at the user\'s responsibility.',
      },
      '第２項．弊社の個人情報の収集と利用': {
        en: 'SECTION 2: OUR COLLECTION AND USE OF PERSONAL INFORMATION',
      },
      '(１)弊社では会員の皆様に最先端の機能やサービスを開発・提供するために、ご利用者様の幾つかの個人情報が必要となります。': {
        en: '1. In order to develop and provide state-of-the-art functions and services to our members, we need some of your personal information.',
      },
      '(２)ご登録メールアドレス・パスワードは、利用者ご自身の責任において管理をお願い致します。': {
        en: '2.  Please manage your registered email address and password at your own responsibility.',
      },
      '１. パスワードは定期的に変更し、他人が類推しやすいような名前や生年月日, 電話番号などはお勧め致しません。': {
        en: '(1) We recommend that you change your password regularly and do not use names, dates of birth, phone numbers, etc. that can be easily guessed by others.',
      },
      '２. 知人・友人などであっても開示・貸与・譲渡しないで下さい。': {
        en: '(2) Do not disclose, lend, or transfer personal information, even if it is an acquaintance or friend.',
      },
      '(３)収集された個人情報は弊社のサービスを提供するために必要な限度においてのみ利用し、次の場合を除き、いかなる第三者にも提供致しません。': {
        en: '3.  Collected personal information will be used only to the extent necessary to provide our services, and will not be provided to any third-party except in the following cases.',
      },
      '１. クレジットカード会社より、カード不正利用の調査のため照会があった場合。': {
        en: '(1) When there is an inquiry from the credit card company to investigate fraudulent use of the card.',
      },
      '２. 会員に対し、広告宣伝のための電子メール,ダイレクトメールを送付する時。': {
        en: '(2) When sending e-mails or direct emails for advertising to members.',
      },
      '３. 個人情報に関する機密保持契約を締結している業務委託会社に対して、ご利用者様に明示した利用目的の達成に必要な範囲で個人情報の取扱いを委託する場合。': {
        en: '(3) When entrusting the handling of personal information to a subcontractor that has concluded a confidentiality agreement regarding personal information to the extent necessary to achieve the purpose of use specified to the user.',
      },
      '４. 弊社における会員の行為が、弊社方針,告知、弊社の利用規約等に違反している場合に、他の会員,第三者または弊社の権利,財産を保護するために必要と認められる時。': {
        en: '(4) When it is deemed necessary to protect the rights and property of other members, third-parties, or our Company when the member\'s actions at our Company violate our Company\'s policies, notices, terms of use, etc...',
      },
      '５. 裁判所,行政機関の命令等,その他法律の定めに従って個人情報の開示を求められた場合、または犯罪の捜査,第三者に対する権利侵害の排除若しくはその予防、その他これに準ずる必要性ある時。': {
        en: '(5) When disclosure of personal information is requested in accordance with the provisions of other laws, such as orders from courts or administrative agencies, or when there is a need to investigate crimes, eliminate or prevent infringement of third-parties, or other equivalent cases.',
      },
      '(４)会員は、弊社に対し、個人情報を上に定める方法で利用することにつきあらかじめ同意するものとし、異議を述べないものとします。': {
        en: '4. The member shall agree in advance to the use of personal information by the method specified above, and shall not raise any objection.',
      },
      '(５)また、弊社では次のような場合、弊社のビジネスパートナーと会員の個人情報を共有する事があります。': {
        en: '5. In addition, in the following cases, we may share the personal information of members with our business partners.',
      },
      '１. 会員向け特別サービスなど、事業的な理由がある場合。この場合、情報を提供する前に会員の同意を求め、同意無しでは提供致しません。': {
        en: '(1) When there is a business reason such as a special service for members. In this case, we will ask for the consent of the member before providing the information, and will not provide it without consent.',
      },
      '２. 統計資料作成、市場調査、データ分析を行う場合。この場合、特定個人を判別することができない様に加工した情報だけを提供致します。': {
        en: '(2) When creating statistical materials, market research, and data analysis. In this case, we will only provide information that has been processed so that it is not possible to identify a specific individual.',
      },
      問い合わせ先: {
        en: 'Contact information',
      },
      'ここに示した個人情報についての考え方についてご不明な点などがございましたら次のminny通販店のリンクから「チャット」もしくは「お問い合わせフォーム」でお問い合わせください。': {
        en: 'If you have any questions about the way of thinking about personal information shown here.',
      },
      minny通販店: {
        en: 'minny',
      },
      弊社メールアドレス: {
        en: 'Our email address',
      },
      'gacha24@iranoan.com': {
        en: 'overseas.gacha24@gmail.com',
      },
      円: {
        en: 'yen',
      },
      'logo.png': {
        en: 'logo_over.png',
      },
      'logo_large.png': {
        en: 'logo_large_over.png',
      },
      '': {
        en: '',
      },
    },
  }),
  methods: {
    t(code) {
      if (this.i18n_mode === 'jp') {
        return code;
      }
      if (this.i18n_message[code]) {
        if (this.i18n_message[code][this.i18n_mode]) {
          return this.i18n_message[code][this.i18n_mode];
        }
      }

      if (this.i18n_mode !== 'jp') {
        console.log(`紐づけなし:${code}`);
      }
      return code;
    },
  },
};
